// http.js
import axios from 'axios'
import QS from 'qs'
import Lockr from 'lockr'
import router from '../router'
import GLOBAL from '../config'
import Message from '../components/message'
import i18n from '../i18n'
import { isWeiXin } from '../utils/tool';

// 环境的切换
if (process.env.NODE_ENV === 'development') {
    // axios.defaults.baseURL = '/api'
} else if (process.env.NODE_ENV === 'production') {
    // axios.defaults.baseURL = GLOBAL.domail
}

// 请求拦截器
axios.interceptors.request.use(config => {
    if(Lockr.get('token')){
        config.headers.common['token'] = Lockr.get('token')
        config.headers.common['language'] = Lockr.get('LANGUAGE')
    }
    return config
},
error => {
    return Promise.error(error)
})

axios.defaults.timeout = 60000

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// sessionid 过期解决
axios.defaults.withCredentials = true

// 响应拦截器
axios.interceptors.response.use(response => {
    if (response.status === 200) {
        if (response.data.code === 405) {
            Lockr.rm('token')
            router.push({
                path: '/login',
                query: {
                    redirect: router.fullPath || '/'
                }
            })
            response.data.msg = i18n.t('response.c_405')
            return Promise.resolve(response)
        } else if (response.data.code === 401) {
            Lockr.rm('token')
            router.push({
                path: '/login',
                query: {
                    redirect: router.fullPath || '/'
                }
            })
            response.data.msg = i18n.t('response.c_401')
            return Promise.resolve(response)
        } else if (response.data.code === 403) {
            response.data.msg = i18n.t('response.c_403')
            return Promise.resolve(response)
        } else if (response.data.code === 404 || response.data.code === 500) {
            response.data.msg = i18n.t('response.c_404')
            setTimeout(()=>{
                router.push('/404')
            },1500)
            return Promise.resolve(response)
        } else if (response.data.code === 503) {
            response.data.msg = i18n.t('response.c_503')
            setTimeout(()=>{
                router.push('/503')
            },1500)
            return Promise.resolve(response)
        } else {
            return Promise.resolve(response)
        }
    } else {
        response.data.msg = i18n.t('response.c_404')
        return Promise.reject(response)
    }
}, error => {
    // console.log('response-error', error)
    if (error && error.stack.indexOf('401') > -1) {
        Lockr.rm('userInfo')
        Lockr.rm('uid')
        Message({
            message: i18n.t('response.c_401'),
            type: "warning"
        });
        setTimeout(()=>{
            router.push({
                path: '/login',
                query: {
                    redirect: router.fullPath || '/'
                }
            })
        },1500)
    }
    if (error && error.stack.indexOf('503') > -1) {
        Message({
            message: i18n.t('response.c_503'),
            type: "warning"
        });
        setTimeout(()=>{
            router.push({
                path: '/503'
            })
        },1500)
    }
    if (error && error.stack.indexOf('500') > -1) {
        Message({
            message: i18n.t('response.c_500'),
            type: "warning"
        });
    }
    // 我们可以在这里对异常状态作统一处理
    let result = {}
    if (error && error.stack.indexOf('timeout') > -1) {
        result.msg = i18n.t('response.timeout')
        Message({
            message: i18n.t('response.timeout'),
            type: "warning"
        });
    }
    if (error && error.stack.indexOf('Network Error') > -1) {
        result.msg = i18n.t('response.network_error')
        Message({
            message: i18n.t('response.network_error'),
            type: "warning"
        });
        setTimeout(()=>{
            // router.push('/502')
        },1500)
    }
    if (error.response.status) {
        result.msg = i18n.t('response.c_404')
        Message({
            message: i18n.t('response.c_404'),
            type: "warning"
        });
        setTimeout(()=>{
            // router.push('/404')
        },1500)
    }
})

let config = {
    headers: {
        'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
    }
};


// get 请求
export function httpGet(url, params = {}) {
    params = {
        ...params,
        system_os: isWeiXin() ? 'wechat' : 'h5',
        token: Lockr.get('token'),
    }
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params
        }).then((res) => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

// post请求
export function uploadFormData(url, params={}) {
    let formData = new FormData();
    for (let i in params) {
        formData.append(i, params[i])
    }
    // formData.append('is_debug', true);
    return new Promise((resolve, reject) => {
        axios.post(url, formData, config)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}

// post请求
export function httpPost(url, params={}) {
    params = {
        ...params,
        system_os: isWeiXin() ? 'wechat' : 'h5',
        token: Lockr.get('token'),
    }
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}

// put
export function httpPut(url, params={}) {
    params = {
        ...params,
        system_os: isWeiXin() ? 'wechat' : 'h5',
        token: Lockr.get('token'),
    }
    let formData = new FormData();
    for (let i in params) {
        formData.append(i, params[i])
    }
    return new Promise((resolve, reject) => {
        axios.put(url, formData, config)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}
// delete
export function httpDelete(url, params={}) {
    params = {
        ...params,
        system_os: isWeiXin() ? 'wechat' : 'h5',
        token: Lockr.get('token'),
    }
    let formData = new FormData();
    for (let i in params) {
        formData.append(i, params[i])
    }
    return new Promise((resolve, reject) => {
        axios.delete(url, formData, config)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}